import styled from "@emotion/styled";
import { TableRow } from "@mui/material";

export const StyledTableRow = styled(TableRow)({
  "&:hover": {
    backgroundColor: "#F5F5F540",
  },
});
